module.exports = __webpack_public_path__ + "imgs/1_gpb.a016eb78.webp";